// styles.
import { StyledColorLegend } from "../styles";

// data.
import { IncentiveStep } from "../rulesData";

const categoryLabels: Record<IncentiveStep["category"], string> = {
  transicion: "Transición",
  bono: "Bono",
  descuento: "Descuento",
  remate: "Remate",
};

export const ColorLegend = () => {
  return (
    <StyledColorLegend data-testid="color-legend">
      <div className="legend-card">
        {(Object.keys(categoryLabels) as IncentiveStep["category"][]).map(
          (category) => (
            <div key={category} className="legend-item">
              <div className={`legend-dot ${category}`} />
              <span className="legend-label">{categoryLabels[category]}</span>
            </div>
          ),
        )}
      </div>
    </StyledColorLegend>
  );
};

